<!--  -->
<template>
  <div>
    <el-form
      :label-position="'right'"
    >
      <el-form-item label="名称">
        <el-input
          v-model="title"
          class="sdawertw"
        />
      </el-form-item>
      <!-- <el-form-item label="内容">
        <el-radio-group v-model="article_url_type">
          <el-radio-button :label="1">文本</el-radio-button>
          <el-radio-button :label="2">h5链接</el-radio-button>
        </el-radio-group>
      </el-form-item> -->
      <!-- <el-form-item label="类型">
        <el-radio-group v-model="article_url_type">
          <el-radio-button :label="1">文案</el-radio-button>
          <el-radio-button :label="2">小说</el-radio-button>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item v-if="article_url_type == 1" label="文章类型">
        <el-radio-group v-model="category_type">
          <el-radio-button :label="1">好文</el-radio-button>
          <el-radio-button :label="2">美食</el-radio-button>
          <el-radio-button :label="3">旅行</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="article_url_type == 1" label="背景颜色">
        <el-color-picker v-model="background_color" />
      </el-form-item>
      <el-form-item>
        <el-button
          v-show="article_url_type == 1"
          type="primary"
          size="mini"
          @click="chaweimg"
        >插入图片到内容</el-button>
        <el-button
          v-show="article_url_type == 1"
          type="primary"
          size="mini"
          style="margin-bottom:10px"
          @click="searchr"
        >插入企微二维码</el-button>
      </el-form-item>

      <el-form-item
        v-show="article_url_type == 1"
        label="内容"
      >
        <br>
        <Editor-wang
          ref="editorwangfour"
          v-model="content"
        />
      </el-form-item>
      <!-- <el-form-item
        label="小说内容"
        v-show="article_url_type == 2"
      >
        <el-input
          type="textarea"
          :rows="20"
          placeholder="请输入小说内容"
          v-model="textarea">
        </el-input>
      </el-form-item> -->
      <!-- <el-form-item
        label="链接"
        v-show="article_url_type == 2"
      >
        <el-input
          v-model="link"
          class="sdawertw"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="封面图">
        <div>
          <img
            v-if="cover_path"
            style="height: 120px; width: 120px;"
            :src="cover_path"
          >
        </div>
        <!-- <el-button
          type="primary"
          size="mini"
          @click="$refs.filerr.click()"
        >上传封面<input
            ref="filerr"
            style="display:none;"
            type="file"
            multiple
            accept="image/gif,image/jpg,image/jpeg,image/png"
            @change="uploadPicturesr"
          ></el-button> -->
        <el-button
          type="primary"
          size="mini"
          @click="chooseimgclickr(1)"
        >上传封面</el-button>
      </el-form-item>
      <el-form-item label="底部按钮图片">
        <div>
          <img
            v-if="base_cover"
            style="height: 120px; width: 120px;"
            :src="base_cover"
          >

        </div>
        <el-button
          type="primary"
          size="mini"
          @click="chooseimgclickr(2)"
        >上传底部按钮图片</el-button>
        <el-button
          v-if="base_cover!=''"
          type="danger"
          size="mini"
          @click="clearwr"
        >清除图片</el-button>
      </el-form-item>
      <el-form-item
        label="客服自定义回复"
      >
        <el-input v-model="base_content" />
      </el-form-item>
      <!-- <el-form-item
        label="选择小程序"
        prop="app_ids"
      >
        <el-button
          style="margin-right:10px"
          type="primary"
          size="mini"
          @click="chooseidsr"
        >选择小程序</el-button>
        <div style="max-height: 80px; overflow-y: auto;display: inline-block;vertical-align: top;">
          <span
            v-for="item, index in app_ids"
            :key="index"
          >
            <el-tag
              v-if="item.sign"
              style="margin-right:10px"
              @close="handleClose(item, index)"
            >{{ item.account_name
            }}</el-tag>
            <el-tag
              v-else
              closable
              style="margin-right:10px"
              @close="handleClose(item, index)"
            >{{ item.account_name
            }}</el-tag>
          </span>
        </div>
      </el-form-item> -->
      <!-- <el-form-item
        label="选择小程序"
        prop="app_ids"
      >
        <el-button
          style="margin-right:10px"
          type="primary"
          size="mini"
          @click="chooseidsr"
        >选择小程序</el-button>
        <div style="max-height: 80px; overflow-y: auto;display: inline-block;vertical-align: top;">
          <span
            v-for="item, index in app_ids"
            :key="index"
          >
            <el-tag
              v-if="item.sign"
              style="margin-right:10px"
              @close="handleClose(item, index)"
            >{{ item.account_name
            }}</el-tag>
            <el-tag
              v-else
              closable
              style="margin-right:10px"
              @close="handleClose(item, index)"
            >{{ item.account_name
            }}</el-tag>
          </span>
        </div>
      </el-form-item>
      <el-form-item
        label="虚拟点赞数"
        prop="virtual_likes"
      >
        <el-input
          v-model="virtual_likes"
          class="sdawertw"
          max="999999"
        />
      </el-form-item>
      <el-form-item
        label="虚拟热度"
        prop="virtual_heat"
      >
        <el-input
          v-model="virtual_heat"
          class="sdawertw"
          max="999999"
        />
      </el-form-item>
      <el-form-item
        label="文章开头视频广告"
        prop="article_start_ad"
      >
        <el-switch
          v-model="article_start_ad"
          :inactive-value="1"
          :active-value="2"
          active-color="#13ce66"
          inactive-color="rgb(191,191,191)"
          :active-text="article_start_ad == 1 ? '关闭' : ''"
          :inactive-text="article_start_ad == 2 ? '开启' : ''"
        />
      </el-form-item>
      <el-form-item
        label="文章激励广告"
        prop="open_encourage"
      >
        <el-switch
          v-model="open_encourage"
          :inactive-value="1"
          :active-value="2"
          active-color="#13ce66"
          inactive-color="rgb(191,191,191)"
          :active-text="open_encourage == 1 ? '关闭' : ''"
          :inactive-text="open_encourage == 2 ? '开启' : ''"
        />
      </el-form-item> -->
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择小程序"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="60%"
    >
      <bandstaff
        ref="bandstaffview"
        @bandarr="bandarr"
      />
    </el-dialog>
    <el-dialog
      title="选择图片"
      :visible.sync="choicedialogVisibleimg"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
    >
      <selectImage @callbackimgs="callbackimgs" />
    </el-dialog>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
    <el-dialog
      title="选择二维码"
      :visible.sync="erweidialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
    >
      <erweima
        ref="erweimaview"
        @callbackerweima="callbackerweima"
      />
    </el-dialog>
  </div>
</template>

<script>
import EditorWang from '../../accountPush/components/AboutView.vue'
import { newMaterial } from '@/api/sourceMaterial.js'
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken.js'
import getNowDate from '@/utils/mixins/convertToHump.js'
import bandstaff from './bandstafftwo.vue'
import { articleSettingstore, articleSettingupdate } from '@/api/workWechat.js'
import selectImage from './selectImage.vue'
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
import erweima from '../../aqiiservice/components/erweima.vue'
export default {
  components: { EditorWang, bandstaff, selectImage, chooseimg, erweima },
  mixins: [getNowDate],
  data() {
    return {
      type: null,
      dialogVisibler: false,
      title: '',
      content: '',
      cover_path: '',
      sourceMaterialId: null,
      app_ids: [],
      virtual_likes: '', // 虚拟点赞数
      virtual_heat: '', // 虚拟热度
      article_start_ad: 2,
      open_encourage: 2,
      article_url_type: 1,
      link: '',
      token: null, // 七牛云token
      arrser: [],
      id: null,
      choicedialogVisibleimg: false,
      dialogVisibletwo: false,
      textarea: '',
      category_type: 1,
      erweidialog: false,
      background_color: '#E8E2BE',
      alltype: null,
      base_cover: '',
      base_content: ''
    }
  },
  created() {
    // this.getQiniuToken()
  },
  mounted() {},
  methods: {
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    async uploadPicturesr(e) {
      const fileIfon = e.target.files[0]
      const img = new Image()
      const video_path = window.URL.createObjectURL(fileIfon)
      img.src = video_path
      // this.ruleForm.video_path = ruleForm.video_path
      console.log('小程序')
      const options = {
        quality: 0.62,
        noCompressIfLarger: false,
        maxWidth: 1000,
        maxHeight: 1000
      }
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      if (ftype !== '.gif') {
        qiniu.compressImage(fileIfon, options).then(data => {
          const observable = qiniu.upload(
            data.dist,
            `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
            this.token,
            {
              fname: fileIfon.name // 文件名
            },
            {
              useCdnDomain: true // cdn域名加速
            }
          )
          observable.subscribe({
            next() {},
            error(err) {
              console.log(err)
            },
            complete: data => {
              newMaterial({
                type: 1,
                height: img.height,
                width: img.width,
                size: fileIfon.size,
                key: data.key
              }).then(res => {
                console.log('res', res)
                this.cover_path = res.data.path
                this.sourceMaterialId = res.data.sourceMaterialId
                this.$message({
                  message: '上传成功',
                  type: 'success'
                })
              })
            }
          })
        })
      } else {
        const observable = qiniu.upload(
          fileIfon,
          `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
          this.token,
          {
            fname: fileIfon.name // 文件名
          },
          {
            useCdnDomain: true // cdn域名加速
          }
        )
        observable.subscribe({
          next() {},
          error(err) {
            console.log(err)
          },
          complete: data => {
            newMaterial({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: data.key
            }).then(res => {
              console.log('res', res)
              this.cover_path = res.data.path
              this.sourceMaterialId = res.data.sourceMaterialId
              this.$message({
                message: '上传成功',
                type: 'success'
              })
            })
          }
        })
      }
    },
    chooseidsr() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.app_ids, this.id)
      })
    },
    async bandarr(arrs) {
      console.log(arrs)
      this.app_ids = []
      this.app_ids = arrs
      this.dialogVisibler = false
    },
    handleClose(item, index) {
      this.app_ids.splice(index, 1)
    },
    send(type, row) {
      this.type = type
      if (this.type === 2) {
        this.app_ids = row.applet_info
        this.title = row.name
        this.content = row.content
        // this.article_url_type = row.article_url_type
        // this.open_encourage = row.open_encourage
        // this.article_start_ad = row.article_start_ad
        // this.virtual_likes = row.virtual_likes
        // this.virtual_heat = row.virtual_heat
        // if (this.article_url_type === 1) {
        //   this.content = row.content
        // }
        // if (this.article_url_type === 2) {
        //   this.link = row.content
        // }
        this.cover_path = row.cover_path
        this.id = row.id
        this.category_type = row.category_type
        this.background_color = row.background_color ? row.background_color : '#E8E2BE'
        this.base_cover = row.base_cover
        this.base_content = row.base_content
      } else {
        // this.virtual_likes = this.generateRandomNumber()
        // this.virtual_heat = this.generateRandomNumber()
      }

      console.log(row)
    },
    generateRandomNumber() {
      // 生成一个 100 到 200000 之间的随机整数
      return Math.floor(Math.random() * (200000 - 100 + 1)) + 100
    },
    // 清洗公众号粘贴 HTML，避免小程序端因固定宽度导致正文右侧裁切
    sanitizeArticleContent(html) {
      if (!html || typeof html !== 'string') return html
      return html
        // 过大的固定宽度（如 width: 699.828px）改为 100%，保留小图标宽度
        .replace(/width\s*:\s*([\d.]+)px/gi, (match, num) => {
          return parseFloat(num) > 300 ? 'width:100%' : match
        })
        .replace(/min-width\s*:\s*([\d.]+)px\s*;?/gi, (match, num) => {
          return parseFloat(num) > 300 ? '' : match
        })
        // 段落左右 2em 在窄屏会挤爆宽度
        .replace(/margin\s*:\s*5px\s+2em\s*;?/gi, 'margin:8px 0;')
        .replace(/margin\s*:\s*([\d.]+(?:px|em)?)\s+2em\s*;?/gi, 'margin:$1 0;')
        // 可见横向溢出改为隐藏，防止撑出屏幕
        .replace(/overflow-x\s*:\s*visible\s*;?/gi, 'overflow-x:hidden;')
        // 保证盒模型不把内容撑出容器（避免重复追加）
        .replace(/style="([^"]*)"/gi, (match, styles) => {
          if (/box-sizing\s*:/i.test(styles)) return match
          return `style="box-sizing:border-box;${styles}"`
        })
    },
    getSubmitContent() {
      if (this.article_url_type !== 1) return this.link
      return this.sanitizeArticleContent(this.content)
    },
    sumbit() {
      if (this.title === '') {
        this.$message.error('请输入文章名称')
        return
      }
      if (this.article_url_type === 1) {
        if (this.content === '') {
          this.$message.error('请输入文章内容')
          return
        }
      }
      if (this.article_url_type === 2) {
        // if (this.link === '') {
        //   this.$message.error('请输入h5链接')
        //   return
        // }
        if (this.textarea === '') {
          this.$message.error('请输入小说内容')
          return
        }
      }
      if (this.cover_path === '') {
        this.$message.error('请上传封面图')
        return
      }
      // if (this.app_ids.length === 0) {
      //   this.$message.error('请选择小程序')
      //   return
      // }
      // if (this.virtual_likes === '') {
      //   this.$message.error('请输入虚拟点赞数')
      //   return
      // }
      // if (this.virtual_heat === '') {
      //   this.$message.error('请输入虚拟热度')
      //   return
      // }
      const articleContent = this.getSubmitContent()
      if (this.article_url_type === 1) {
        this.content = articleContent
      }
      if (this.type === 1) {
        console.log('新增')
        // this.arrser = []
        // this.arrser = this.app_ids.map(item => {
        //   return item.app_id
        // })

        articleSettingstore({
          name: this.title,
          content: articleContent,
          cover_path: this.cover_path,
          category_type: this.category_type,
          background_color: this.background_color,
          base_cover: this.base_cover,
          base_content: this.base_content
          // article_url_type: this.article_url_type,
          // article_start_ad: this.article_start_ad,
          // open_encourage: this.open_encourage,
          // app_ids: this.arrser,
          // virtual_likes: this.virtual_likes,
          // virtual_heat: this.virtual_heat
        }).then(res => {
          console.log('res', res)
          this.$emit('updatar')
          this.$message({
            message: '新增成功',
            type: 'success'
          })
        })
      } else {
        console.log('编辑')
        // this.arrser = []
        // this.arrser = this.app_ids.map(item => {
        //   return item.app_id
        // })
        articleSettingupdate({
          name: this.title,
          content: articleContent,
          cover_path: this.cover_path,
          category_type: this.category_type,
          background_color: this.background_color,
          base_cover: this.base_cover,
          base_content: this.base_content,
          // article_url_type: this.article_url_type,
          // article_start_ad: this.article_start_ad,
          // open_encourage: this.open_encourage,
          // app_ids: this.arrser,
          id: this.id
          // virtual_likes: this.virtual_likes,
          // virtual_heat: this.virtual_heat
        }).then(res => {
          console.log('res', res)
          this.$emit('updatar')
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        })
      }

      console.log(this.content, this.app_ids)
    },
    chaweimg() {
      this.choicedialogVisibleimg = true
    },
    callbackimgs(item, type) {
      console.log('777777777777777777')
      this.choicedialogVisibleimg = false
      console.log(item, type)
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        console.log('进1')
        this.$refs.editorwangfour.send(item, 1)
        // eslint-disable-next-line eqeqeq
      } else if (type == 2) {
        console.log('进2')
        // console.log(this.encodeSearchKey(item.link))
        this.$refs.editorwangfour.send(item, 6)
      }
    },
    chooseimgclickr(type) {
      this.alltype = type
      this.dialogVisibletwo = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      this.dialogVisibletwo = false
      console.log(img, key)
      // eslint-disable-next-line eqeqeq
      if (this.alltype == 1) {
        this.cover_path = img
        this.sourceMaterialId = key
      } else {
        this.base_cover = img
      }
    },
    clearwr() {
      this.base_cover = ''
    },
    callbackerweima(item, type) {
      console.log(item, type)
      this.erweidialog = false
      this.$refs.editorwangfour.send({ id: 1, path: item.qr_code }, 1)
    },
    searchr() {
      this.erweidialog = true
      this.$nextTick(() => {
        this.$refs.erweimaview.send()
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sdawertw {
  width: 300px;
}
::v-deep .el-switch__label--right,
::v-deep .el-switch__label--left {
  background-color: #fff !important;
}
</style>
